"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopicContent = TopicContent;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _grommet = require("grommet");
var _utils = require("grommet/utils");
var _grommetIcons = require("grommet-icons");
var _reactI18next = require("react-i18next");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["content", "onInternalLink", "onImageClick"];
var _templateObject; // import ReactHtmlParser from 'react-html-parser';
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var StyledContentBox = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .table td,\n  .table th {\n    padding: 0.75rem;\n    vertical-align: top;\n    ", "\n  }\n  a {\n    ", "\n    ", "\n  }\n  .image {\n    max-width: 100%;\n    cursor: pointer;\n  }\n  .shortdesc > .xref {\n    box-sizing: border-box;\n    font-size: inherit;\n    line-height: inherit;\n    color: rgb(111, 111, 111);\n    font-weight: 500;\n    text-decoration: underline;\n    cursor: pointer;\n  }\n  .shortdesc > .xref:after {\n    display: inline-flex;\n    content: '';\n    background-image: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path d='M20.924 3.617a.997.997 0 0 0-.215-.322l-.004-.004A.997.997 0 0 0 20 3h-6a1 1 0 1 0 0 2h3.586l-7.293 7.293a1 1 0 1 0 1.414 1.414L19 6.414V10a1 1 0 1 0 2 0V3.997a.999.999 0 0 0-.076-.38zM3 8a5 5 0 0 1 5-5h1a1 1 0 0 1 0 2H8a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-1a1 1 0 1 1 2 0v1a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5V8z' fill='%236f6f6f'></path></svg>\");\n    background-size: 16px 16px;\n    background-repeat: no-repeat;\n    background-position-x: right;\n    height: 16px;\n    width: 16px;\n    padding-right: 6px;\n  }\n  .uicontrol {\n    font-weight: bold;\n  }\n  h1 {\n    font-size: 24px;\n    line-height: 24px;\n    color: #444444;\n    font-weight: 500;\n  }\n  h2 {\n    font-size: 20px;\n    line-height: 20px;\n    color: #444444;\n    font-weight: 500;\n  }\n  h3 {\n    font-size: 16px;\n    line-height: 16px;\n    color: #444444;\n    font-weight: 600;\n  }\n  h4 {\n    font-size: 12px;\n    line-height: 12px;\n    color: #444444;\n    font-weight: 600;\n  }\n"])), function (props) {
  return "border-top: 1px solid ".concat((0, _utils.normalizeColor)('border', props.theme), ";");
}, function (props) {
  return "color: ".concat((0, _utils.normalizeColor)('text', props.theme), ";");
}, function (props) {
  return "font-weight: ".concat(props.theme.anchor.fontWeight, ";");
});
var prepareHTML = function prepareHTML(str) {
  return str ? str.replace(/(<h1>)([\w\W]*)(<\/pre>)/gi, '') : '';
};
var isInlineUrl = function isInlineUrl(url) {
  return url && url.indexOf('/hpesc/public/api/document') !== -1;
};
function Content(_ref) {
  var content = _ref.content,
    onInternalLink = _ref.onInternalLink,
    onImageClick = _ref.onImageClick,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = (0, _react.useContext)(_grommet.ThemeContext);
  var ref = (0, _react.useRef)();
  var onInternalLinkRef = (0, _react.useRef)(onInternalLink);
  var onImageClickRef = (0, _react.useRef)(onImageClick);

  // tracking the click handlers so we don't have to
  // reprocess the DOM if they change
  (0, _react.useEffect)(function () {
    onInternalLinkRef.current = onInternalLink;
  }, [onInternalLink]);
  (0, _react.useEffect)(function () {
    onImageClickRef.current = onImageClick;
  }, [onImageClick]);
  (0, _react.useEffect)(function () {
    if (ref.current) {
      ref.current.querySelectorAll('a').forEach(function (link) {
        if (isInlineUrl(link.href)) {
          link.addEventListener('click', function (e) {
            e.preventDefault();
            if (onInternalLinkRef.current) {
              onInternalLinkRef.current(e);
            }
          });
        }
      });
      ref.current.querySelectorAll('.image').forEach(function (image) {
        if (isInlineUrl(image.src)) {
          image.addEventListener('click', function (e) {
            e.preventDefault();
            if (onImageClickRef.current) {
              onImageClickRef.current(e);
            }
          });
        }
      });
    }
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledContentBox, _objectSpread({
    ref: ref,
    theme: theme
    // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
    ,
    dangerouslySetInnerHTML: {
      __html: prepareHTML(content)
    }
  }, rest));
}
Content.propTypes = {
  content: _propTypes["default"].string,
  onInternalLink: _propTypes["default"].func,
  onImageClick: _propTypes["default"].func
};
function TopicContent(_ref2) {
  var content = _ref2.content,
    topicUrl = _ref2.topicUrl,
    testId = _ref2.testId,
    onInternalLink = _ref2.onInternalLink,
    onImageClick = _ref2.onImageClick;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return content ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_grommet.Box, {
    align: "start",
    children: [topicUrl && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_grommet.Box, {
      direction: "row",
      gap: "xsmall",
      align: "center",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_grommet.Anchor, {
        href: topicUrl,
        target: "_blank",
        color: "text",
        label: t('support_lnk'),
        "data-testid": "".concat(testId, "-link")
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_grommetIcons.ShareRounded, {
        size: "small"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Content, {
      "data-testid": testId,
      content: content,
      onInternalLink: onInternalLink,
      onImageClick: onImageClick
    })]
  }) : null;
}
TopicContent.propTypes = {
  content: _propTypes["default"].string,
  topicUrl: _propTypes["default"].string,
  testId: _propTypes["default"].string.isRequired,
  onInternalLink: _propTypes["default"].func,
  onImageClick: _propTypes["default"].func
};